export default __webpack_public_path__ + "static/media/spinner.51a2c80a.gif";